import { Post } from '@tribeplatform/gql-client/types'
import { Badge } from '@tribeplatform/react-ui-kit/Badge'

import { DotSeparator } from '../common/components/DotSeparator.js'
import { dayjs } from '../common/lib/dayjs.js'
import { T } from '../i18n/index.js'

interface Props {
  updatedAt?: Post['updatedAt']
  scheduledFor?: Post['scheduledFor']
}

export const DraftPostHeader = ({ updatedAt, scheduledFor }: Props) => {
  if (scheduledFor) {
    return (
      <T
        defaultMessage="{badge} {separator} Publishing at {date}"
        id="Post.PostHeader.ScheduledPost"
        values={{
          badge: (
            <Badge variant="highlight" size="sm">
              <T defaultMessage="Scheduled" id="Generics.Scheduled" />
            </Badge>
          ),
          separator: <DotSeparator className="mx-1" />,
          date: dayjs(scheduledFor).format('DD/MMM/YYYY HH:mm'),
        }}
      />
    )
  }

  return (
    <T
      defaultMessage="{badge} {separator} Last saved {date}"
      id="Post.PostHeader.DraftPost"
      values={{
        badge: (
          <Badge variant="attention" size="sm">
            <T defaultMessage="Draft" id="Generics.Draft" />
          </Badge>
        ),
        separator: <DotSeparator className="mx-1" />,
        date: dayjs(updatedAt).fromNow(),
      }}
    />
  )
}
